import { Link, Navigate } from '@tanstack/react-router';
import ScreenTabTileContent, {
  screenTabTileClass,
  screenTabTileGridClass,
} from '@/components/ui/ScreenTabTile.tsx';
import { useIsMobile } from '@/hooks/use-mobile.tsx';
import type { DetailsTabMenuLink } from './DetailsHeader';

interface DetailsTabMenuProps {
  /** Zakładki ekranu w kolejności; pierwsza jest domyślną na szerokim ekranie. */
  tabs: DetailsTabMenuLink[];
}

/**
 * Treść gołego adresu rekordu — tego bez segmentu zakładki.
 *
 * Na telefonie to menu: zakładki jako kafle pod nagłówkiem rekordu, bo w rzędzie
 * mieszczą się dopiero od `md`. Szeroko menu nie ma czego pokazać (rząd zakładek
 * jest już w nagłówku), więc adres odbija na pierwszą zakładkę.
 *
 * Druga, reaktywna odnoga tej samej decyzji jest tu nie bez powodu: `beforeLoad`
 * trasy indeksowej nie uruchamia się ponownie przy zmianie rozmiaru okna, więc
 * bez niej poszerzenie okna zostawiałoby szeroki ekran z kaflami.
 */
const DetailsTabMenu = ({ tabs }: DetailsTabMenuProps) => {
  const isMobile = useIsMobile();
  const [firstTab] = tabs;

  if (!isMobile) {
    return (
      <Navigate
        to={firstTab.to}
        params={firstTab.params}
        search={firstTab.search}
        replace
      />
    );
  }

  return (
    <div className={screenTabTileGridClass}>
      {tabs.map((tab) => (
        <Link
          key={tab.label}
          to={tab.to}
          params={tab.params}
          search={tab.search}
          className={screenTabTileClass}
        >
          <ScreenTabTileContent
            icon={tab.icon}
            label={tab.label}
            hint={tab.hint}
          />
        </Link>
      ))}
    </div>
  );
};

export default DetailsTabMenu;
